var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expand-row"},[_c('Table',{attrs:{"border":"","stripe":"","columns":_vm.columns2,"data":_vm.row}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }